import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ResetPasswordService } from '../../core/services/reset-password.service';
import { BehaviorSubject } from 'rxjs';
import { ValidationUtils } from '../../core/utils/ValidationUtils';
import { AlertService } from '../../core/services/alert.service';

@Component({
  selector: 'app-forgot-password-form',
  templateUrl: './forgot-password-form.component.html',
})
export class ForgotPasswordFormComponent implements OnInit {
  form = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    captchaGroup: new UntypedFormGroup({ captcha: new UntypedFormControl(null, [Validators.required]) }),
    username: new UntypedFormControl('', [Validators.pattern(ValidationUtils.USERNAME_PATTERN)])
  });
  private captchaResponse: string;
  resetCaptcha$ = new BehaviorSubject<boolean>(false);
  resetSuccess = new BehaviorSubject<boolean>(false);
  showUsername$ = new BehaviorSubject<boolean>(false);
  loading$ = this.resetPasswordService.loading$;

  constructor(
    private resetPasswordService: ResetPasswordService,
    private alertService: AlertService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.showUsername$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((show) => {
        const usernameControl = this.form.get('username');
        if (show) {
          usernameControl.addValidators(Validators.required);
        } else {
          usernameControl.removeValidators(Validators.required);
        }
        usernameControl.updateValueAndValidity();
      });

    this.form.get('email').valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        if (this.showUsername$.value) {
          this.showUsername$.next(false);
          this.form.get('username').setValue('');
        }
      });
  }

  submit(): void {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      const email = this.form.get('email')?.value;
      const username = this.form.get('username')?.value;
      this.resetPasswordService
        .requestResetToken(email, this.captchaResponse, username)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(
          () => {
            this.form.disable();
            this.resetSuccess.next(true);
          },
          (response) => {
            this.resetCaptcha$.next(true);
            if (response.status === 409) {
              this.showUsername$.next(true);
            } else if (response.status === 404) {
              this.alertService.error('login.forgetPassword.errors.404');
            } else {
              this.form.get('email').setErrors({ email: true });
            }
          }
        );
    }
  }

  captchaGroup(): UntypedFormGroup {
    return this.form.get('captchaGroup') as UntypedFormGroup;
  }

  onCaptchaVerified(captchaResponse: string): void {
    this.captchaResponse = captchaResponse;
  }
}
